<article class="prose lg:prose-xl"></article>
<div [class.border-b]="isFullHide" [ngClass]="containerClass ? containerClass.join(' ') : ''" class="relative h-full rounded-md border-slate-300 pt-10">
  <div class="hidden" [innerHtml]="value" id="pre"></div>
  @if(isTopBard){
    <app-top-bar
      [ngClass]="topBarClass ? topBarClass.join(' ') : ''"
      class="absolute top-0 w-full opacity-80 z-20"
      [topBarItemsConfig]="topBarItemsConfig"
      (topBarAction)="topBarAction($event)"
      (topBarExpand)="topBarExpand($event)"
      [provider]="provider"
      [isFullHide]="isFullHide"
    />
  }
  <div [ngClass]="(isExpand || isFullHide) ? 'max-h-screen' : 'max-h-96 max-sm:max-h-64 overflow-auto overscroll-none'" class="ctn min-h-60 px-0">
    <ng-milkdown-provider #provider>
      <ng-milkdown
        [config]="config"
        [plugins]="plugins"
        [(ngModel)]="value"
        [(loading)]="loading"
        (ngModelChange)="onChange($event)"
        (onReady)="onEditorReady($event)"
        [spinner]="spinner"
      />
      <ng-template #spinner>
        <app-spinner />
      </ng-template>
    </ng-milkdown-provider>
  </div>
</div>
